<div class="col-xs-12 col-sm-4" style="max-width: inherit">
  <div
    id="general_search"
    *ngIf="hasEntitlement('SEARCH_SHIP')"
    class=""
    style="width:auto"
  >
    <div class="dropdown">
      <form
        class="input-group ng-pristine ng-invalid ng-invalid-required"
        name="searchForm"
        appDropdown
      >
        <input
          type="search"
          class="form-control"
          dropdown-toggle
          required
          placeholder="Search ship location"
          style="width:auto"
          name="searchForm"
          #searchField
          (click)="onInputClick()"
          (keyup.enter)="startNewSearch()"
        />
        <span id="search_button" class="input-group-btn">
          <button class="btn btn-nc" type="button" (click)="startNewSearch()">
            <i class="fa fa-search"></i>
          </button>
        </span>
      </form>
      <ul class="dropdown-menu" #dropdownMenu [ngClass]="{ show: menuOpen }">
        <li class="recentSearchHeader">RECENT SEARCHES</li>
        <li class="ng-scope">
          <div class="searchResults ng-scope">
            <app-ship-search-results
              (shipSelected)="shipSelected($event)"
              [results]="shipSearchResultArray"
            >
            </app-ship-search-results>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
